import request from '@/utils/request'
// 登录
export function login(data){
    return request({
        url: 'api/login/login',
        method: 'post',
        data
    })
} 
export function sendSms(data){
    return request({
        url: 'api/login/sendSms',
        method: 'post',
        data
    })
} 
// 注册
export function register(data){
    return request({
        url: 'api/login/register',
        method: 'post',
        data
    })
} 

export function forgetPayPassword(data){
    return request({
        url: 'api/usercenter/forgetPayPassword',
        method: 'post',
        data
    })
} 
// 协议
export function agreement(){
    return request({
        url: 'api/login/agreement',
        method: 'get'
    })
} 
export function forgetPassword(data){
    return request({
        url: 'api/login/forgetPassword',
        method: 'post',
        data
    })
} 
export function noticeList(){
    return request({
        url: 'api/login/registerIdea',
        method: 'get'
    })
} 
